import React from 'react';
import { func } from 'prop-types';
import { X } from 'wix-ui-icons-common';

import styles from './close-bar.scss';

const CloseBar = ({ onClose }) => (
  <div className={styles.container} onClick={onClose} data-hook="close-bar">
    <X size="18px" />
  </div>
);

CloseBar.propTypes = {
  onClose: func.isRequired,
};

export default CloseBar;
